import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { useEventInfo } from '@shared/utils/eventInfo';

export interface AdminDashboardUpdateEventStartDatePayload
  extends Readonly<{
    eventStartDate?: string;
  }> {}

const isValidPayload = (payload: unknown): payload is AdminDashboardUpdateEventStartDatePayload => {
  return typeof payload === 'object' && payload !== null && ('eventStartDate' in payload ? typeof payload.eventStartDate === 'string' : true);
};

/**
 * Admin Dashboard Update Feature Flag Logic
 * For a dashboard to show the update it must be a new event created after a specific date
 * and the feature flag must be enabled
 */
export const useIsAdminDashboardUpdateEnabled = () => {
  const { eventInfo } = useEventInfo();

  const [isAdminDashboardUpdateEventStartDateOn, , , payload] = useIsFeatureEnabled('adminDashboardUpdateEventStartDate');
  const adminDashboardUpdateEventStartDatePayload = isValidPayload(payload) ? payload : {};

  const createdDate = new Date(eventInfo?.firebaseCreateAt?.timestamp || 0);
  const startDate = new Date(adminDashboardUpdateEventStartDatePayload?.eventStartDate || 0);

  const isNewEvent = createdDate.toISOString().split('T')[0] >= startDate.toISOString().split('T')[0];

  const [isAdminDashboardUpdateEnabled] = useIsFeatureEnabled('adminDashboardUpdate');

  return isAdminDashboardUpdateEnabled && isAdminDashboardUpdateEventStartDateOn && isNewEvent;
};
